
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'SidebarList',
  props: {
    label: String,
  },
});
